import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

type AllData = {
    content: {
        isFeed?: boolean;
        text?: string;
    };
};

const ForwardText = ({ content }: AllData) => {
    const isFeed = content.isFeed || false;

    return content?.text ? (
        <div className={isFeed ? styles.feedForwardText : styles.articleForwardText}>转载自 {content?.text}</div>
    ) : null;
};

export default errorBoundary(ForwardText);
